module.exports = __webpack_public_path__ + "img/kit sycamore.f04bd94f.png";